import { render, staticRenderFns } from "./News.vue?vue&type=template&id=84caf1ec&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/static-pages/news.scss?vue&type=style&index=0&id=84caf1ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84caf1ec",
  null
  
)

export default component.exports